export var mediaQueries = {
    SM: "(min-width: 640px)",
    MD: "(min-width: 768px)",
    LG: "(min-width: 1024px)",
    '2LG': "(min-width: 1100px)",
    XL: "(min-width: 1280px)",
    '2XL': "(min-width: 1440px)",
};
export var gaAffiliation = 'Hays Travel';
